import { render, staticRenderFns } from "./ListModel.vue?vue&type=template&id=4de27759&"
import script from "./ListModel.vue?vue&type=script&lang=js&"
export * from "./ListModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports